<template>
  <header class="nav-container">
    <!-- LOGO: Se queda anclado a la izquierda -->
    <div class="nav-logo">
      <a href="/" @click.prevent="reloadHome">
        <img src="@/assets/Img/Logo_Navar/logo_sin_fondo_recortado.png" alt="JHC Ingenieros" />
      </a>
    </div>

    <!-- NAVEGACIÓN ESCRITORIO -->
    <nav class="nav-links">
      <ul>
        <li><a href="/" @click.prevent="reloadHome"><i class="fas fa-home"></i> Inicio</a></li>
        <li><a href="#servicios" @click.prevent="scrollToServicios"><i class="fas fa-cogs"></i> Servicios</a></li>
        <li><a href="/catalogo" @click.prevent="goToCatalogo"><i class="fas fa-book"></i> Catálogo</a></li>
        <li><a href="/contactanos" @click.prevent="goToContactanos"><i class="fas fa-envelope"></i> Contáctanos</a></li>
        <li><a href="#" @click.prevent="abrirAsistente" class="nav-consultar"><img src="@/assets/jean-bot.png" alt="Asistente IA" class="nav-bot-icon" /> Asistente IA</a></li>
        <li><a href="carrito" target="_blank"><i class="fas fa-store"></i> Tienda</a></li>
        <li><a href="https://system.jeaninformatico.com/login" target="_blank" class="nav-login"><i class="fas fa-sign-in-alt"></i> Iniciar sesión</a></li>
      </ul>
    </nav>

    <!-- BOTÓN HAMBURGUESA / CERRAR (Cambia de icono según el estado) -->
    <button class="nav-toggle" @click.stop="toggleMenu" :aria-label="isOpen ? 'Cerrar menú' : 'Abrir menú'">
      <i class="fas" :class="isOpen ? 'fa-times' : 'fa-bars'"></i>
    </button>

    <!-- FONDO OSCURO (OVERLAY) AL ABRIR EL MENÚ -->
    <transition name="fade">
      <div v-if="isOpen" class="nav-overlay" @click="closeMenu"></div>
    </transition>

    <!-- MENÚ MÓVIL (PANEL LATERAL SIN LA "X" INTERNA) -->
    <transition name="slide-panel">
      <div class="nav-mobile" v-if="isOpen">
        
        <!-- Ya no hay botón X aquí arriba -->
        
        <ul>
          <li><a href="/" @click.prevent="reloadHome"><i class="fas fa-home"></i> Inicio</a></li>
          <li><a href="#servicios" @click.prevent="scrollToServiciosAndClose"><i class="fas fa-cogs"></i> Servicios</a></li>
          <li><a href="/catalogo" @click.prevent="goToCatalogo"><i class="fas fa-book"></i> Catálogo</a></li>
          <li><a href="/contactanos" @click.prevent="goToContactanos"><i class="fas fa-envelope"></i> Contáctanos</a></li>
          <li><a href="#" @click.prevent="abrirAsistenteAndClose"><img src="@/assets/jean-bot.png" alt="Asistente IA" class="nav-bot-icon" /> Asistente IA</a></li>
          <li><a href="carrito" target="_blank" @click="closeMenu"><i class="fas fa-store"></i> Tienda</a></li>
          <li class="nav-mobile-login-wrapper">
            <a href="https://system.jeaninformatico.com/login" target="_blank" @click="closeMenu" class="nav-login">
              <i class="fas fa-sign-in-alt"></i> Iniciar sesión
            </a>
          </li>
        </ul>
      </div>
    </transition>
  </header>
</template>

<script>
export default {
  name: 'NavbarWorld',
  data() {
    return { isOpen: false };
  },
  methods: {
    toggleMenu() { this.isOpen = !this.isOpen; },
    closeMenu() { this.isOpen = false; },

    safeNavigate(path) {
      if (this.$route.path !== path) {
        this.$router.push(path).catch(err => {
          if (err.name !== 'NavigationDuplicated') throw err;
        });
      }
      this.closeMenu();
    },

    reloadHome() {
      if (this.$route.path === '/') window.location.reload();
      else this.safeNavigate('/');
    },

    goToCatalogo() { this.safeNavigate('/catalogo'); },
    goToContactanos() { this.safeNavigate('/contactanos'); },

    abrirAsistente() {
      const rootApp = this.$root.$children[0];
      const asistente = rootApp && rootApp.$refs ? rootApp.$refs.asistente : null;
      if (asistente && typeof asistente.abrirAsistente === 'function') {
        asistente.abrirAsistente();
      }
    },

    abrirAsistenteAndClose() {
      this.abrirAsistente();
      this.closeMenu();
    },

    scrollToServicios() {
      if (this.$route.path !== '/') {
        this.$router.push('/').then(() => {
          this.$nextTick(() => this.scrollToSection('servicios'));
        }).catch(err => {
          if (err.name !== 'NavigationDuplicated') throw err;
        });
      } else {
        this.scrollToSection('servicios');
      }
    },

    scrollToServiciosAndClose() {
      this.scrollToServicios();
      this.closeMenu();
    },

    scrollToSection(sectionId) {
      const section = document.getElementById(sectionId);
      if (section) section.scrollIntoView({ behavior: 'smooth' });
    },

    handleKeydown(e) {
      if (e.key === 'Escape' && this.isOpen) this.closeMenu();
    }
  },
  watch: {
    '$route'() { this.closeMenu(); },
    isOpen(val) {
      if (window.innerWidth <= 900) {
        document.body.style.overflow = val ? 'hidden' : '';
      }
    }
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeydown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown);
    document.body.style.overflow = '';
  }
};
</script>

<style scoped>
/* ============================================================
   CONTENEDOR PRINCIPAL (TRANSPARENTE Y FLOTANTE)
   ============================================================ */
.nav-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: transparent;
  padding: 0.5rem 2rem;
  color: white;
  z-index: 1000;
  min-height: 90px;
}

/* ============================================================
   LOGO
   ============================================================ */
.nav-logo {
  position: relative;
  z-index: 1002;
}

.nav-logo img {
  height: 110px;
  width: auto;
  object-fit: contain;
  transition: all 0.3s ease;
  filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.6));
}

/* ============================================================
   ESCRITORIO
   ============================================================ */
.nav-links { margin-left: auto; }
.nav-links ul {
  display: flex;
  gap: 1.8rem;
  list-style: none;
  margin: 0;
  padding: 0;
  align-items: center;
}
.nav-links a {
  color: #fff;
  text-decoration: none;
  font-weight: 600;
  font-size: 0.95rem;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  white-space: nowrap;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.7);
  transition: color 0.3s ease;
}
.nav-links a:hover { color: #00e5ff; }

.nav-login {
  padding: 0.55rem 1.3rem !important;
  border: 2px solid #00bcd4;
  border-radius: 25px;
  background: rgba(0, 188, 212, 0.15);
  font-weight: 700 !important;
}
.nav-login:hover {
  background: linear-gradient(135deg, #00bcd4, #0097a7);
  color: #0a1f44 !important;
  box-shadow: 0 8px 25px rgba(0, 188, 212, 0.5);
}

/* ============================================================
   BOTÓN HAMBURGUESA / CERRAR (Móvil)
   ============================================================ */
.nav-toggle {
  display: none;
  background: rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.2);
  font-size: 1.5rem;
  color: white;
  cursor: pointer;
  padding: 0.5rem 0.9rem;
  border-radius: 8px;
  transition: all 0.3s ease;
  backdrop-filter: blur(5px);
  z-index: 1003; /* 🔥 Z-INDEX MÁS ALTO PARA QUE ESTÉ SOBRE EL PANEL */
  margin-left: auto;
}

.nav-toggle:hover {
  background: rgba(0, 188, 212, 0.3);
}

/* ============================================================
   OVERLAY Y PANEL MÓVIL
   ============================================================ */
.nav-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(3px);
  z-index: 1000;
}

/* Panel Móvil Deslizante */
.nav-mobile {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 85%;
  max-width: 320px;
  background: rgba(15, 20, 25, 0.95); 
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: -10px 0 30px rgba(0, 0, 0, 0.6);
  border-left: 1px solid rgba(255, 255, 255, 0.1);
  z-index: 1002;
  display: flex;
  flex-direction: column;
}

/* 🔥 Subimos un poco el padding-top de la lista para que no choque con el botón X */
.nav-mobile ul {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin: 0;
  padding: 4.5rem 1.5rem 1.5rem; 
  overflow-y: auto;
}

.nav-mobile a {
  color: white;
  text-decoration: none;
  font-weight: 500;
  font-size: 1rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.9rem 1rem;
  border-radius: 10px;
  transition: all 0.2s ease;
}
.nav-mobile a i {
  color: #00bcd4;
  font-size: 1.1rem;
  width: 24px;
  text-align: center;
}
.nav-mobile a:hover, .nav-mobile a:active {
  background: rgba(255, 255, 255, 0.1);
  transform: translateX(4px);
}

.nav-mobile-login-wrapper {
  margin-top: auto;
  padding-top: 2rem;
}
.nav-mobile .nav-login {
  justify-content: center;
  background: rgba(0, 188, 212, 0.1);
  border: 1px solid #00bcd4;
  padding: 1rem !important;
}
.nav-mobile .nav-login i { color: white; }

/* ============================================================
   ANIMACIONES
   ============================================================ */
.fade-enter-active, .fade-leave-active { transition: opacity 0.3s ease; }
.fade-enter-from, .fade-leave-to { opacity: 0; }

.slide-panel-enter-active, .slide-panel-leave-active { transition: transform 0.4s cubic-bezier(0.22, 1, 0.36, 1); }
.slide-panel-enter-from, .slide-panel-leave-to { transform: translateX(100%); }

/* ============================================================
   RESPONSIVE
   ============================================================ */
@media (max-width: 1024px) {
  .nav-container { padding: 0.5rem 1.5rem; }
  .nav-links ul { gap: 1rem; }
  .nav-logo img { height: 95px; }
}

@media (max-width: 900px) {
  .nav-container {
    padding: 0.5rem 1.2rem;
    min-height: 85px;
  }
  
  .nav-links { display: none; }
  .nav-toggle { display: flex; align-items: center; justify-content: center; }
  
  .nav-logo img { height: 85px; } 
}

@media (max-width: 480px) {
  .nav-container { padding: 0.5rem 1rem; min-height: 75px; }
  .nav-logo img { height: 75px; } 
  .nav-toggle { font-size: 1.4rem; padding: 0.5rem 0.8rem; }
}

@media (max-width: 360px) {
  .nav-container { padding: 0.4rem 0.8rem; min-height: 65px; }
  .nav-logo img { height: 65px; }
}

/* ============================================================
   ICONO ASISTENTE IA (PERSONAJE JEAN-BOT SIN CÍRCULO)
   ============================================================ */
.nav-bot-icon {
  height: 28px;
  width: auto;
  max-width: 28px;
  object-fit: contain;
  border: none;
  border-radius: 0;
  box-shadow: none;
  display: inline-block;
  vertical-align: middle;
  flex-shrink: 0;
  filter: drop-shadow(0 2px 5px rgba(0, 0, 0, 0.4));
  transition: transform 0.25s ease, filter 0.25s ease;
}

.nav-links a:hover .nav-bot-icon {
  transform: scale(1.18);
  filter: drop-shadow(0 0 10px rgba(0, 229, 255, 0.85));
}

.nav-mobile a .nav-bot-icon {
  height: 30px;
  max-width: 30px;
}

</style>